module.exports = __webpack_public_path__ + "media/images/weather/34_day-f1a131cf880cf6cf963bfdea1ea50fe0.png";